import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { EventsService } from 'src/app/services/eventsService';
import { UserService } from 'src/app/services/user-service';


@Component({
    selector: 'app-ril-notes',
    templateUrl: './ril-notes.component.html',
    styleUrls: ['./ril-notes.component.scss'],
    standalone: false
})
export class RilNotesComponent implements OnInit {

  @Input() note: string;
  form: FormGroup;
  enableSalva = false;
  userRole: string;
  readOnly: boolean;

  constructor(
    public modalCtrl: ModalController,
    public events: EventsService,
    public formBuilder: FormBuilder,
    public userService: UserService
    ) {
        this.form = this.formBuilder.group({
            note: [
                "",
                Validators.compose([
                Validators.maxLength(1000),
                ])
              ]
        })
     }

  ngOnInit() {
    this.form.controls['note'].setValue(this.note);
    if(this.note) {
      this.readOnly = true;
    }
    else {
      this.readOnly = false;
    }
    this.userRole = this.userService.getUtenteCorrente().ruolo;
  }

  async annulla() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }

  enableForm() {
    this.readOnly = false;
    this.enableSalva = true;
  }

  async salvaNota() {
    this.enableSalva = false;
    if(this.note) {
      this.readOnly = true;
    }
    if(this.form.get('note').value != this.note) {
      await this.modalCtrl.dismiss(this.form.value, 'cancel');
    } 
  }

}